<template>
 <!-- 合同模板审核 -->
  <div>
    <div v-show="HtmbSH">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">合同模板审核</div>
    <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
      <!-- 查询框 -->
      <div style="margin-left:3%">
        <div style="height:40px"></div>
        <span>合同员工分类 </span>
        <el-select v-model="value" style="margin-left:10px;width:160px" placeholder="请选择分类">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

        <div style="display:inline-block;margin-left:20px">
          <span>生效日期 </span>
          <el-date-picker
            style="width:160px;margin-left:10px"
            v-model="riqi1"
            type="date"
            placeholder="请选择">
          </el-date-picker>
          <span>&nbsp;-&nbsp;</span>
          <el-date-picker
          style="width:160px"
            v-model="riqi2"
            type="date"
            placeholder="请选择">
          </el-date-picker>
        </div>

        <div style="display:inline-block;margin-left:20px">
          <span>状态 </span>
        <el-select v-model="value" style="margin-left:10px;width:160px" placeholder="请选择状态">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        </div>

        <!-- 按钮 -->
        <div style="display:inline-block;margin-left:50px">
          <el-button type="goon" @click="Find">查询</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <div style="margin:3% 3% 0 3%">
        <el-table
          :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
          :row-class-name="tableRowClassName"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;" height='540'
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="template_name" align="center" label="员工合同模板名称"></el-table-column>
          <el-table-column prop="dictionaries_id" align="center" label="员工合同分类"></el-table-column>
          <el-table-column prop="template_date" align="center"  label="生效日期"></el-table-column>
          <el-table-column prop="" align="center" label="状态" width=100>
            <template slot-scope="scope">
                <img src="../../../assets/stateImg/状态_待审核.png" v-show="scope.row.template_state === '0'" />
                <img src="../../../assets/stateImg/状态_已同意.png" v-show="scope.row.template_state === '1'" />
                <img src="../../../assets/stateImg/状态_已同意.png" v-show="scope.row.template_state === '3'" />
                <img src="../../../assets/stateImg/状态_已驳回.png" v-show="scope.row.template_state === '2'" />
            </template>
          </el-table-column>
          <el-table-column prop="states" align="center" label="操作">
            <template slot-scope="scope">
              <img src="../../../assets/详情.png" @click="xiangqing(scope.row)">
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-row style="margin-top: 10px; text-align: center;">
          <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
            layout=" prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-row>
      </div>
      
    </div>
    </div>
    <edit ref="edits" v-show="showedit"></edit>
  </div>
</template>

<script>
import edit from './HtmbSh_edit.vue';
export default {
  components: {
    edit:edit,
  },
  data() {
    return {
      page_num: 1,
      page_size: 10,
      total: 0,
      tableData:[],
      ruleForm:{
        id:"",
        template_name:"",
        dictionaries_id:"",
        template_date:"",
        template_content:"",
        template_url:"",
        template_state:"",
        reviewer_name:"",
        reviewer_date:"",
        reject_reason:"",
        dictionaries_name:"",
        start_date:"",
        end_date:"",
      },
      // 权限
      HtmbSH:true,
      showedit:false,
      ids: [],
      //条件
      condition: {
        id:"",
        dictionaries_id: "",
        start_date:"",
        end_date:"",
        template_date:"",
      },
    }
  },
  methods: {
    // 全选
    handleSelectionChange(val) {
        this.ids = [];
        e.forEach(item => {
        this.ids.push(item.id);
      })
    },
    // 返回
    Return(){
        this.showedit = false;
        this.HtmbSH = true;
    },
    // 操作详情
    xiangqing(e){
      this.HtmbSH = false;
      this.showedit = true;
      this.ruleForm.id=e.id;
      this.ruleForm.dictionaries_id = e.dictionaries_id;
      this.ruleForm.start_date = e.start_date;
      this.ruleForm.end_date = e.end_date;
      this.ruleForm.template_date = e.template_date;
      this.ruleForm.template_content = e.template_content;
      this.ruleForm.template_url = e.template_url;
      this.ruleForm.template_state = e.template_state;
      this.ruleForm.reviewer_name = e.reviewer_name;
      this.ruleForm.reviewer_date = e.reviewer_date;
      this.ruleForm.reject_reason = e.reject_reason;
      this.ruleForm.dictionaries_name = e.dictionaries_name;
      this.ruleForm.start_date = e.start_date;
      this.ruleForm.end_date = e.end_date;
      this.ruleForm.template_name = e.template_name;
    },
    //查询
    async Find() {
      var url = "template/selectAll";
      var record = {
        page_num: this.page_num,
        page_size: this.page_size,
        data_grouping: "HtmbGl",
        template_name: this.ruleForm.template_name,
        dictionaries_id:this.ruleForm.dictionaries_id,
        start_date:this.ruleForm.start_date,
        end_date:this.ruleForm.end_date,
        template_content:this.ruleForm.template_content,
        template_url:this.ruleForm.template_url,
        template_state:this.ruleForm.template_state,
        reviewer_name:this.ruleForm.reviewer_name,
        reviewer_date:this.ruleForm.reviewer_date,
        reject_reason:this.ruleForm.reject_reason,
        dictionaries_name:this.ruleForm.dictionaries_name,
        start_date:this.ruleForm.start_date,
        end_date:this.ruleForm.end_date,
      };
      var data = await this.$globals.AxiosPost(url, record);
      if (data === "-2000") {
          this.$message.error("服务器未响应！请稍后重试");
      } else {
          var code = data.code;
          var data = data.data;
          if (code === '200') {
              this.tableData = data.list;
              this.total = data.total;
          } else {
              this.$message.warning("请求失败！请稍后重试");
          }
      }
    },
    //分页
    handleCurrentChange(val) {
        this.page_num = val;
        this.Find();
    },
  //清除数据
    trash() {
      this.ruleForm.id = "";
      this.ruleForm.template_name= "";
      this.ruleForm.dictionaries_id= "";
      this.ruleForm.template_date= "";
      this.ruleForm.template_content= "";
      this.ruleForm.template_url= "";
      this.ruleForm.template_state= "";
      this.ruleForm.reviewer_name= "";
      this.ruleForm.reviewer_date= "";
      this.ruleForm.reject_reason= "";
      this.ruleForm.dictionaries_name= "";
      this.ruleForm.start_date= "";
      this.ruleForm.end_date= "";
    }
  },
  created(){
    this.Find();
  }
}
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006E4B;
  border-color:  #05573d;
  color: #fff;
}
.el-button--addbtn:focus,
.el-button--addbtn:hover {
  background: #fff;
  border-color:  #05573d;
  color:  #006E4B;
}
.el-button--goon {
  color: #FFF;
  background-color: #006E4B;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-button--addbtn {
  color:  #006E4B;
  background-color: #fff;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color:  #006E4B;
  border-color:  #006E4B;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color:  #006E4B;
}
.el-checkbox__inner:hover{
  border-color:  #006E4B;
}

</style>


// WEBPACK FOOTER //
// HtmbSh.vue?b6ee9650